var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { pick } from 'lodash';
import React from 'react';
import { ODWebUtils } from '../../../utils';
import { actionSetDeleting, actionSetLoading, actionSetSaving, actionSetUrlToRedirect, actionValueLoaded, LoadedValueType, } from './action';
import { createEntityEditorReducer, createInitialReducerState, ODEntityState } from './reducer';
function defaultDiffClientValue(updated, original) {
    var keysChanged = [];
    Object.keys(original).forEach(function (key) {
        // @ts-ignore
        if (updated[key] !== original[key]) {
            keysChanged.push(key);
        }
    });
    return pick.apply(void 0, __spreadArrays([updated], keysChanged));
}
export function useODEntity(resourceId, api, options, refreshToken) {
    var _this = this;
    var isCreating = resourceId === null;
    var defaultCreateClientData = options.defaultCreateClientData, diffClientValue = options.diffClientValue, urlAfterCreation = options.urlAfterCreation, urlAfterUpdate = options.urlAfterUpdate, urlAfterDelete = options.urlAfterDelete, createSuccessMessage = options.createSuccessMessage, createSuccessTitle = options.createSuccessTitle, updateSuccessMessage = options.updateSuccessMessage, updateSuccessTitle = options.updateSuccessTitle, deleteSuccessMessage = options.deleteSuccessMessage, deleteSuccessTitle = options.deleteSuccessTitle, isSingleton = options.isSingleton;
    var _a = React.useReducer(createEntityEditorReducer(), createInitialReducerState()), state = _a[0], dispatch = _a[1];
    var currentState = state.state, initialValue = state.initialValue;
    var onUnexpectedError = React.useCallback(function (ex) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // tslint:disable-next-line:no-console
            console.error("ODEntityContext met unexpected error");
            // tslint:disable-next-line:no-console
            console.error(ex);
            ODWebUtils.showError(ex);
            return [2 /*return*/];
        });
    }); }, []);
    var loadInitialData = React.useCallback(function (itemId) { return __awaiter(_this, void 0, void 0, function () {
        var iValue, ex_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(actionSetLoading(true));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 5, 6]);
                    return [4 /*yield*/, api.load(itemId)];
                case 2:
                    iValue = _a.sent();
                    dispatch(actionValueLoaded(iValue, LoadedValueType.InitialLoaded));
                    return [3 /*break*/, 6];
                case 3:
                    ex_1 = _a.sent();
                    // TODO: how to handle this gracefully?
                    return [4 /*yield*/, onUnexpectedError(ex_1)];
                case 4:
                    // TODO: how to handle this gracefully?
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    dispatch(actionSetLoading(false));
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [isCreating]);
    var loadSingletonInitialData = React.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var iValue, ex_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(actionSetLoading(true));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 5, 6]);
                    return [4 /*yield*/, api.loadLatest()];
                case 2:
                    iValue = _a.sent();
                    dispatch(actionValueLoaded(iValue, LoadedValueType.InitialLoaded));
                    return [3 /*break*/, 6];
                case 3:
                    ex_2 = _a.sent();
                    // TODO: how to handle this gracefully?
                    return [4 /*yield*/, onUnexpectedError(ex_2)];
                case 4:
                    // TODO: how to handle this gracefully?
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    dispatch(actionSetLoading(false));
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [isCreating]);
    var onSubmit = React.useCallback(function (data) { return __awaiter(_this, void 0, void 0, function () {
        var updatedValue, url, diff, _a, updatedValue, url, ex_3;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch(actionSetSaving(true, currentState === ODEntityState.LoadedInitialForCreation));
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 9, , 10]);
                    if (!(currentState === ODEntityState.LoadedInitialForCreation)) return [3 /*break*/, 3];
                    return [4 /*yield*/, api.create(data)];
                case 2:
                    updatedValue = _c.sent();
                    dispatch(actionValueLoaded(updatedValue, LoadedValueType.UpdateLoaded));
                    url = urlAfterCreation(updatedValue);
                    ODWebUtils.showSuccess((createSuccessMessage !== null && createSuccessMessage !== void 0 ? createSuccessMessage : 'Success'), (createSuccessTitle !== null && createSuccessTitle !== void 0 ? createSuccessTitle : ''));
                    dispatch(actionSetUrlToRedirect(url));
                    return [3 /*break*/, 8];
                case 3:
                    if (!!!diffClientValue) return [3 /*break*/, 5];
                    return [4 /*yield*/, diffClientValue(data, initialValue)];
                case 4:
                    _a = _c.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _a = defaultDiffClientValue(data, initialValue);
                    _c.label = 6;
                case 6:
                    diff = _a;
                    if (!diff) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, api.update(diff, data, initialValue)];
                case 7:
                    updatedValue = _c.sent();
                    dispatch(actionValueLoaded(updatedValue, LoadedValueType.UpdateLoaded));
                    ODWebUtils.showSuccess((updateSuccessMessage !== null && updateSuccessMessage !== void 0 ? updateSuccessMessage : 'Success'), (updateSuccessTitle !== null && updateSuccessTitle !== void 0 ? updateSuccessTitle : ''));
                    url = (_b = urlAfterUpdate) === null || _b === void 0 ? void 0 : _b(updatedValue);
                    if (url) {
                        dispatch(actionSetUrlToRedirect(url));
                    }
                    else {
                        dispatch(actionSetSaving(false, false));
                    }
                    _c.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    ex_3 = _c.sent();
                    dispatch(actionSetSaving(false, currentState === ODEntityState.LoadedInitialForCreation));
                    // noinspection ES6MissingAwait
                    onUnexpectedError(ex_3);
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); }, [initialValue]);
    var onDelete = React.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var url, ex_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(actionSetDeleting(true));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.delete(initialValue)];
                case 2:
                    _a.sent();
                    url = urlAfterDelete(initialValue);
                    dispatch(actionSetUrlToRedirect(url));
                    ODWebUtils.showSuccess((deleteSuccessMessage !== null && deleteSuccessMessage !== void 0 ? deleteSuccessMessage : 'Success'), (deleteSuccessTitle !== null && deleteSuccessTitle !== void 0 ? deleteSuccessTitle : ''));
                    return [3 /*break*/, 4];
                case 3:
                    ex_4 = _a.sent();
                    dispatch(actionSetDeleting(false));
                    // noinspection ES6MissingAwait
                    onUnexpectedError(ex_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [initialValue]);
    React.useEffect(function () {
        if (api.load && (resourceId || isSingleton)) {
            if (resourceId) {
                // noinspection JSIgnoredPromiseFromCall
                loadInitialData(resourceId);
            }
            else {
                // noinspection JSIgnoredPromiseFromCall
                loadSingletonInitialData();
            }
        }
        else {
            dispatch(actionValueLoaded(defaultCreateClientData, LoadedValueType.InitialCreating));
        }
    }, [resourceId, isSingleton, refreshToken]);
    var context = {
        state: state,
        onSubmit: onSubmit,
        onDelete: onDelete,
        isCreating: [ODEntityState.LoadedInitialForCreation, ODEntityState.SavingCreates].includes(state.state),
    };
    return context;
}
//# sourceMappingURL=useODEntity.js.map